function methodAssign(event, method, elements) {
  for (let i of elements) {
    i.addEventListener(event, method, false);
  }
}

window.onload = function () {
  //Set aria-label to clipboards
  const clipboards = document.querySelectorAll(".copy-to-clipboard-button span");
  clipboards.forEach(function (element) {
    element.setAttribute("aria-label", "Copiar código fuente");
  });
};

function initSearchBarCDN() {
  const inputSearch = document.querySelectorAll(
    ".input-search-cdn-govco:not(.noActive)"
  );
  getElementInputSearchBar(inputSearch);
  methodAssign("keyup", activeInputSearchBar, inputSearch);
  methodAssign("keydown", keydownInputSearchBar, inputSearch);
  methodAssign("blur", blurInputSearchBar, inputSearch);
  methodAssign("focus", focusInputSearchBar, inputSearch);

  const buttonClean = document.querySelectorAll(
    ".document-search-cdn-govco .icon-close-search-govco"
  );
  methodAssign("click", cleanInputSearchBar, buttonClean);
  methodAssign("blur", blurcleanInputSearchBar, buttonClean);
}

function getElementInputSearchBar(elements) {
  for (let i of elements) {
    assignFunctionItemsSearchBar(i);
  }
}

function activeInputSearchBar(element) {
  const parent = element.target.parentNode;
  const existsClass = parent.classList.contains("active");
  if (element.target.value === "") {
    parent.classList.remove("active", "exist-content");
  } else if (!existsClass) {
    parent.classList.add("active", "exist-content");
  }
}

function assignFunctionItemsSearchBar(input) {
  const parentInput = input.parentNode;
  const parentItems = parentInput.nextElementSibling;
  const items = parentItems.querySelectorAll("ul li a");

  for (let item of items) {
    item.removeEventListener("keydown", eventkeydown, true);
    item.removeEventListener("blur", eventBlur, true);
    item.removeEventListener("click", eventClick, true);

    item.addEventListener("keydown", eventkeydown);
    item.addEventListener("blur", eventBlur);
    item.addEventListener("click", eventClick);
  }
}

function eventkeydown(e) {
  const element = e.target;
  const parent = element.closest('.search-principal-govco');
  const parentInput = parent.querySelector('.bar-search-govco');
  const parentItems = parentInput.nextElementSibling;
  const input = parent.querySelector('input');
  keysUpDownSearchBar(e, parentItems, input);
}

function eventBlur(e) {
  const item = e.target;
  const elementI = item.parentNode;
  const elementU = elementI.parentNode;
  const elementDivOptions = elementU.parentNode;
  const elementDivContainerOptions = elementDivOptions.parentNode;
  const elementDivContainerSearch =
    elementDivContainerOptions.previousElementSibling;
  existFocusContainerSearchBar(elementDivContainerSearch);
}

function eventClick(e) {
  const element = e.target;
  const parent = element.closest('.search-principal-govco');
  const parentInput = parent.querySelector('.bar-search-govco');
  const input = parent.querySelector('input');
  input.value = "";
  parentInput.classList.remove("active", "exist-content");
}

function keydownInputSearchBar(element) {
  const parentInput = this.parentNode;
  const parentItems = parentInput.nextElementSibling;
  const parentUl = parentItems.querySelector('.options-search-govco');

  if (parentUl) {
    parentUl.onscroll = function () {
      const visibleItems = this.querySelectorAll("li a");
      if (document.activeElement == visibleItems[0]) {
        this.scrollTop = 0;
      }
    };
    keysUpDownSearchBar(element, parentItems, this);
  }
}

function keysUpDownSearchBar(e, container, input) {
  // Key up
  if (e.which == 38) {
    upSearchBar(container, input);
  }
  // Key down
  if (e.which == 40) {
    downSearchBar(container, input);
  }
}

function downSearchBar(container, input) {
  const active = document.activeElement;
  const items = container.querySelectorAll("li a");
  if (active === input) {
    items[0].focus();
  } else {
    for (let i = 0; i < items.length - 1; i++) {
      if (active === items[i]) {
        items[i + 1].focus();
      }
    }
  }
}

function upSearchBar(container, input) {
  const active = document.activeElement;
  const itemsList = container.querySelectorAll("li:not(.none) a");
  if (active === itemsList[0]) {
    input.focus();
  } else {
    for (let i = 1; i < itemsList.length; i++) {
      if (active === itemsList[i]) {
        itemsList[i - 1].focus();
      }
    }
  }
}

function cleanInputSearchBar() {
  const input = this.previousElementSibling;
  const parent = this.parentNode;
  input.value = "";
  parent.classList.remove("active", "exist-content");
  input.focus();
}

function blurInputSearchBar() {
  const parent = this.parentNode;
  existFocusContainerSearchBar(parent);
}

function existFocusContainerSearchBar(element) {
  setTimeout(() => {
    if (!element.parentNode.contains(document.activeElement)) {
      element.classList.remove("active");
    }
  }, 100);
}

function focusInputSearchBar(element) {
  activeInputSearchBar(element);
}

function blurcleanInputSearchBar() {
  const parent = this.parentNode;
  existFocusContainerSearchBar(parent);
}

// =================================== Cabecera =================================== \\ 

function initSearchBarEjm() {
  setTimeout(() => {
    const inputSearch = document.querySelectorAll(".input-ejm-search-govco:not(.noActive)");

    document.querySelectorAll('.button-ejm-responsive-menu-govco').forEach(function (element) {
      element.addEventListener("click", eventDeployResMenuEjm, false);
    });

    getElementInputSearchBar(inputSearch);
    methodAssign("keyup", activeInputSearchBarEjm, inputSearch);
    methodAssign("keydown", keydownInputSearchBar, inputSearch);
    methodAssign("blur", blurInputSearchBar, inputSearch);
    methodAssign("focus", focusInputSearchBar, inputSearch);

    const buttonClean = document.querySelectorAll(".search-ejm-govco .icon-close-search-govco");
    methodAssign("click", cleanInputSearchBarEjm, buttonClean);
    methodAssign("blur", blurcleanInputSearchBar, buttonClean);
  }, "1000");
}

function activeInputSearchBarEjm(element) {
  const parent = element.target.parentNode;
  const existsClass = parent.classList.contains("active");
  const buttonClean = document.querySelectorAll(".search-ejm-govco .icon-close-search-govco");
  const listado = document.querySelectorAll(".container-ejm-options-search-govco");

  if (element.target.value === "") {
    listado[0].classList.add("hidden")
    buttonClean[0].classList.add("hidden")
    parent.classList.remove("active", "exist-content");
  } else if (element.target.value != "") {
    listado[0].classList.remove("hidden")
    buttonClean[0].classList.remove("hidden")
    parent.classList.add("active", "exist-content");
  } else if (!existsClass) {
    parent.classList.add("active", "exist-content");
    console.log("parent", parent)
  }
}

function cleanInputSearchBarEjm() {
  const input = this.previousElementSibling;
  const parent = this.parentNode;
  const buttonClean = document.querySelectorAll(".search-ejm-govco .icon-close-search-govco");
  const listado = document.querySelectorAll(".container-ejm-options-search-govco");
  input.value = "";
  listado[0].classList.add("hidden")
  buttonClean[0].classList.add("hidden")
  parent.classList.remove("active", "exist-content");
  input.focus();
}

function eventDeployResMenuEjm() {
  const navbar = document.querySelectorAll(".escoden-barra");
  const bottomBar = document.querySelectorAll(".bottom-bar-resp-cont-govco");
  const barsIcon = document.querySelectorAll(".icon-bars-menu-govco");

  if (navbar[0].classList.contains("hidden")) {
    navbar[0].classList.remove("hidden")
    bottomBar[1].classList.add("hidden")
    barsIcon[1].classList.add("opened")
  } else {
    navbar[0].classList.add("hidden")
    bottomBar[1].classList.remove("hidden")
    barsIcon[1].classList.remove("opened")
  }
}
